import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllOAuthProvidersKey, OAUTH_PROVIDERS_ENDPOINT } from "./useGetAllOAuthProviders";

type UpsertOAuthProviderOptions = {
    id?: number;
    payload: Record<string, unknown>;
};

export const useUpsertOAuthProvider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async ({ id, payload }: UpsertOAuthProviderOptions) => {
            if (id === undefined) {
                return loggedInApiCall.post(OAUTH_PROVIDERS_ENDPOINT, payload);
            }

            return loggedInApiCall.patch(`${OAUTH_PROVIDERS_ENDPOINT}/${id}`, payload, {
                headers: { "Content-Type": "application/merge-patch+json" },
            });
        },
        onSuccess: () => queryClient.invalidateQueries([getAllOAuthProvidersKey]),
    });

    return query;
};
